export class FaxParty {
    public Name: string;
    public FaxNumber: string;
    public PhoneNumber: string;
    public Company: string;
}
